
import { Core } from "@/core/Core";

export default {

  /* Choice item */

  async getChoiceItems(context, {inventoryId}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/choice_items?augment=backend&admin=true`);
    } catch (e) {
      return null;
    }
  },

  async getChoiceItem(context, {inventoryId, id}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/choice_items/${id}?augment=backend`);
    } catch (e) {
      return null;
    }
  },

  async createChoiceItem(context, {inventoryId, data}) {
    try {
      return await Core.request("POST", `/api/inventory/${inventoryId}/choice_items`, data);
    } catch (e) {
      return null;
    }
  },

  async saveChoiceItem(context, {inventoryId, itemId, data}) {
    try {
      return await Core.request("PUT", "/api/inventory/" + inventoryId + "/choice_items/" + itemId, data);
    } catch (e) {
      return null;
    }
  }

}